import { AxiosInstance } from 'axios';
import { ChildGroupsRepository } from '@/model/repository/shift/ChildGroupsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ChildGroupsRepository => ({
    index() {
      return Repository.get(`${resource}`);
    },
  });
